<template>
  <a-modal
    :visible="visible"
    title="拆解"
    :confirm-loading="loading"
    @ok="handleOk"
    @cancel="onClose"
  >
    <a-form-model label="上级工单号">
      <a-input
        v-model="billNos"
        allowClear
        placehoder="请输入要拆解的单号，多个用逗号隔开"
      />
    </a-form-model>

  </a-modal>
</template>

<script>
import { apiCcDiscreteJobsDisassembly } from '@/api/mes/workOrderManage/ticketsManageCc'

export default {
  name: 'CancelModal',
  data () {
    return {
      visible: false,
      loading: false,
      billNos: undefined
    }
  },
  methods: {
    show () {
      this.visible = true
      this.billNos = undefined
    },
    // 驳回
    onClose () {
      this.visible = false;
      this.billNos = undefined
    },
    // 取消
    handleOk () {
      if(!this.billNos) {
        this.$message.warning('请输入要拆解的单号')
        return
      }
      const wipEntityNames = this.billNos.split(/\s+/);
      this.loading = true;
      apiCcDiscreteJobsDisassembly(wipEntityNames).then(res => {
        if(res.code === 200) {
          this.$message.success(res.data || '操作成功')
          this.onClose();
          this.$emit('successCall');
        }else {
          this.$message.error(res.msg)
        }
      }).finally(() => {
        this.loading = false;
      })
    }
  }
}
</script>

<style scoped>

</style>
